import Cookie from 'js-cookie';

import { EnvConfig } from '@/env_config';

type CookieAttributes = Cookies.CookieAttributes;

const { cookieDomain } = EnvConfig;

function isSecure(): boolean {
	if (typeof window !== 'undefined') {
		return window.location.protocol === 'https:';
	}
	return false;
}

const cookieOptions = {
	secure: isSecure(),
	domain: cookieDomain,
};

// 🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪
function get(key: string): string | undefined {
	return Cookie.get(key);
}

function set(key: string, value: string, options = {}): void {
	Cookie.set(key, value, { ...options, ...cookieOptions });
}

function remove(key: string, options?: CookieAttributes): void {
	const defaultOptions = { path: '/' };
	Cookie.remove(key, { ...defaultOptions, ...(options ?? cookieOptions) });
}
// 🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪🍪

const _exports = {
	get,
	set,
	remove,
};
export default _exports;
